import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { CaregiverPerformanceGridOptionsHeaderComponent } from '../caregiver-performance-grid-options-header/caregiver-performance-grid-options-header.component';
import { CaregiverPerformanceGridSearchComponent } from '../caregiver-performance-grid-search/caregiver-performance-grid-search.component';
import { CaregiverPerformanceGridComponent } from '../caregiver-performance-grid/caregiver-performance-grid.component';

@Component({
  selector: 'app-caregiver-performance-grid-container',
  templateUrl: './caregiver-performance-grid-container.component.html',
  styleUrls: ['./caregiver-performance-grid-container.component.scss'],
  standalone: true,
  imports: [
    CaregiverPerformanceGridOptionsHeaderComponent,
    CaregiverPerformanceGridSearchComponent,
    CaregiverPerformanceGridComponent,
  ],
})
export class CaregiverPerformanceGridContainerComponent implements OnInit {

  constructor() { }

  allCaregiverCount: number;
  allCaregiverTabLabel: string;
  allowExportToCsv: boolean;
  sort: MatSort;
 
  ngOnInit(): void {
    // TODO: set this for real
    this.allCaregiverCount = 50;
    this.allCaregiverTabLabel = `All Caregivers (${this.allCaregiverCount})`;
  }
}
